"use client"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import type { ThreadAction } from "@/lib/conversation/thread-header"

interface ConfirmActionDialogProps {
  /** The action awaiting an answer, or null when nothing is being asked. */
  action: ThreadAction | null
  onCancel: () => void
  onConfirm: (action: ThreadAction) => void
}

/**
 * The question a `confirm` descriptor carries, asked once for every action that
 * carries one. A surface with a richer dialog of its own — the agent inbox
 * explains what an exclusion matches on — keeps it and does not use this.
 */
export function ConfirmActionDialog({ action, onCancel, onConfirm }: ConfirmActionDialogProps) {
  return (
    <AlertDialog open={action !== null} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{action?.label}</AlertDialogTitle>
          <AlertDialogDescription>{action?.confirm}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={() => action && onConfirm(action)}>
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
